import { get as idbGet } from 'idb-keyval';

export const get = async (idbKey) => {
  try {
    return await idbGet(idbKey);
  } catch (error) {
    if (error?.name === 'InvalidStateError') {
      // Wait for a short while so that idb-keyval can open a new connection
      await new Promise((resolve) => setTimeout(resolve, 50));
      try {
        return await idbGet(idbKey);
      } catch (err) {
        console.error(`Retry failed to get from ${idbKey}`, { err });
        throw err;
      }
    }

    console.error(`Could not get from ${idbKey}`, { error });
    throw error;
  }
};
